import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "19",
  viewBox: "0 0 22 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19 17.9414V10.9414M11 17.9414V7.94141M3 17.9414L3 13.9414M12.4067 2.96891L17.5751 4.90708M9.79877 3.34233L4.20023 7.54123M20.0607 4.38075C20.6464 4.96653 20.6464 5.91628 20.0607 6.50207C19.4749 7.08785 18.5251 7.08785 17.9393 6.50207C17.3536 5.91628 17.3536 4.96653 17.9393 4.38075C18.5251 3.79496 19.4749 3.79496 20.0607 4.38075ZM4.06066 7.38075C4.64645 7.96653 4.64645 8.91628 4.06066 9.50207C3.47487 10.0879 2.52513 10.0879 1.93934 9.50207C1.35355 8.91628 1.35355 7.96653 1.93934 7.38075C2.52513 6.79496 3.47487 6.79496 4.06066 7.38075ZM12.0607 1.38075C12.6464 1.96653 12.6464 2.91628 12.0607 3.50207C11.4749 4.08785 10.5251 4.08785 9.93934 3.50207C9.35355 2.91628 9.35355 1.96653 9.93934 1.38075C10.5251 0.79496 11.4749 0.79496 12.0607 1.38075Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }